import { render, staticRenderFns } from "./ScoreResult.vue?vue&type=template&id=abe83816&lang=html&"
import script from "./ScoreResult.vue?vue&type=script&lang=js&"
export * from "./ScoreResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports